import { IContextConfirmConfig } from "./confirm.types";

export const DIALOG_CONFIG_INITIAL: IContextConfirmConfig = {
  ButtonCancelProps: {},
  ButtonConfirmProps: {},
};
